import React, { useCallback, useState } from 'react'
import Slick from 'react-slick'

function DefaultSlider(props) {
  const { children, ...rest } = props;
  const [swiped, setSwiped] = useState(false)

  const handleSwiped = useCallback(() => {
    setSwiped(true)
  }, [setSwiped])

  const handleOnItemClick = useCallback(
    (e) => {
      if (swiped) {
        e.stopPropagation()
        e.preventDefault()
        setSwiped(false)
      }
    },
    [swiped],
  )

  return (
    <Slick
      onSwipe={handleSwiped}
      {...rest}
    >
      {React.Children.map(children, child => (
        <div onClickCapture={handleOnItemClick}>{child}</div>
      ))}
    </Slick>
  )
}

export default DefaultSlider
